import { PATHS } from '@/app/router/paths'
import { AuthLayout, AuthLegalFooter, RustWordmark } from './AuthLayout'
import { LoginForm } from './AuthForms'

export default function ClientLoginPage() {
  return (
    <AuthLayout backTo={PATHS.role} backLabel="Terug naar rolkeuze">
      <RustWordmark width={140} />
      <h1 className="auth-headline" style={{ fontSize: 26 }}>
        Inloggen als cliënt
      </h1>
      <p className="auth-subtitle">Welkom terug. Log in om je dag te openen.</p>
      <LoginForm role="client" />
      <AuthLegalFooter />
    </AuthLayout>
  )
}
